import React from 'react';
import { render } from 'react-dom';
import Wrapper from '../wrapper/wrapper';
import FacebookIcon from '../../ui/icons/facebook';
import LinkedinIcon from '../../ui/icons/linkedin';

const init = () => {
  const footerContainer = document.getElementById('footer');
  if (footerContainer) {
    render(<Footer />, footerContainer);
  }
};

const Footer: React.FC = () => {
  return (
    <footer className="relative w-full m-[0] bg-grey-100 pt-14 pb-8">
      <div className="absolute top-[0] h-[2px] w-full bg-gradient-to-r from-[#96BD0D] via-[#FED100] to-[#BE0B25]"></div>
      <Wrapper>
        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 md:gap-16 lg:gap-20">
          <div className="col-span-3 mb-10 md:col-span-1 md:mb-[0]">
            <img className="h-12" src="/logos/ea48.svg" alt="Energieausweis48 Logo" />
          </div>
          <div className="display-none lg:block"></div> {/* empty column for spacing */}
          <div>
            <div className="flex flex-col">
              <div className="mb-2 text-sm text-grey-500">Social media</div>
              <ul className="flex gap-1">
                <li>
                  <a href="https://www.facebook.com/Energieausweis48" target="_blank">
                    <FacebookIcon className="text-3xl text-[#2a64f6]" />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/energieausweis48/" target="_blank">
                    <LinkedinIcon className="text-3xl text-[#2e6eaa]" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div className="mb-2 text-sm text-grey-500">Hilfe</div>
            <ul>
              <li>
                <a
                  href={window.footerRoutes?.faq}
                  className="inline-block pt-1 text-md text-black hover:text-primary-300 hover:no-underline"
                >
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href={window.footerRoutes?.contact}
                  className="inline-block pt-1 text-md text-black hover:text-primary-300 hover:no-underline"
                >
                  Kontakt
                </a>
              </li>
              <li>
                <a
                  href="/api"
                  className="inline-block pt-1 text-md text-black hover:text-primary-300 hover:no-underline"
                >
                  API
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="mb-2 text-sm text-grey-500">Allgemein</div>
            <ul>
              <li>
                <a
                  href={window.footerRoutes?.impressum}
                  className="inline-block pt-1 text-md text-black hover:text-primary-300 hover:no-underline"
                >
                  Impressum
                </a>
              </li>
              <li>
                <a
                  href={window.footerRoutes?.agb}
                  className="inline-block pt-1 text-md text-black hover:text-primary-300 hover:no-underline"
                >
                  AGB
                </a>
              </li>
              <li>
                <a
                  href={window.footerRoutes?.datenschutz}
                  className="inline-block pt-1 text-md text-black hover:text-primary-300 hover:no-underline"
                >
                  Datenschutz
                </a>
              </li>
              <li>
                <a
                  href={window.footerRoutes?.kundeninformation}
                  className="inline-block pt-1 text-md text-black hover:text-primary-300 hover:no-underline"
                >
                  Kundeninfo
                </a>
              </li>
              <li>
                <a
                  href={window.footerRoutes?.stornierungskosten}
                  className="inline-block pt-1 text-md text-black hover:text-primary-300 hover:no-underline"
                >
                  Stornierungskosten
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 flex gap-20 justify-between">
          <p className="text-sm text-grey-400">&copy; {new Date().getFullYear().toString()} Energieausweis48 GmbH</p>
        </div>
      </Wrapper>
    </footer>
  );
};

export default Footer;
init();
